export default __webpack_public_path__ + "public/assets/images/d5b4a02e8ded4db316f2ceecd78907e9.png";